import { ArrowSquareOut, Lightning, MapPin, PlayCircle } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { getStoryThumbnailUrl } from "@/utils/storyMedia";
import { getStoryDisplayTitle } from "@/utils/storySections";

export const MajorSceneCard = ({ story, rank }) => {
  if (!story) {
    return null;
  }

  const displayTitle = getStoryDisplayTitle(story);
  const thumbnailUrl = getStoryThumbnailUrl(story);

  return (
    <article className="border border-[rgba(10,15,26,0.12)] bg-white p-4 shadow-sm" data-testid={`major-scene-card-${story.slug}`}>
      <div className="flex items-start gap-4">
        <div className="relative w-28 shrink-0 overflow-hidden rounded-[1rem] border border-[rgba(10,15,26,0.12)] bg-slate-950 aspect-[9/16]" data-testid={`major-scene-media-${story.slug}`}>
          <img alt={displayTitle} className="h-full w-full object-cover" src={thumbnailUrl} />
          <div className="absolute inset-x-0 top-0 bg-gradient-to-b from-slate-950/90 to-transparent p-2 text-white">
            <div className="inline-flex items-center gap-2 bg-[#D21404] px-2 py-1 text-[10px] font-bold uppercase tracking-[0.16em]" data-testid={`major-scene-rank-${story.slug}`}>
              <Lightning size={12} weight="fill" />
              Pinned #{rank}
            </div>
          </div>
          <div className="absolute inset-x-0 bottom-0 p-2">
            <div className="inline-flex items-center gap-2 bg-white/95 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-slate-950" data-testid={`major-scene-format-${story.slug}`}>
              <PlayCircle size={12} weight="fill" />
              {story.content_type}
            </div>
          </div>
        </div>

        <div className="min-w-0 flex-1">
          <p className="eyebrow text-red-600" data-testid={`major-scene-overline-${story.slug}`}>Major scene</p>
          <h3 className="mt-2 font-['Outfit'] text-2xl font-bold tracking-tight text-slate-950" data-testid={`major-scene-title-${story.slug}`}>{displayTitle}</h3>
          <p className="mt-3 text-sm leading-7 text-slate-700" data-testid={`major-scene-excerpt-${story.slug}`}>{story.excerpt}</p>
          <p className="mt-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-500" data-testid={`major-scene-location-${story.slug}`}>
            <MapPin size={14} weight="bold" />
            {story.location}
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            <Button asChild className="rounded-none bg-[#D21404] px-4 py-3 text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-[#B31203]" data-testid={`major-scene-story-button-${story.slug}`}>
              <Link to={`/stories/${story.slug}`}>Open story</Link>
            </Button>
            <Button asChild className="rounded-none border border-slate-950 bg-transparent px-4 py-3 text-xs font-bold uppercase tracking-[0.2em] text-slate-950 hover:bg-slate-950 hover:text-white" data-testid={`major-scene-source-button-${story.slug}`} variant="ghost">
              <a href={story.permalink} rel="noreferrer" target="_blank">
                Source
                <ArrowSquareOut size={14} weight="bold" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </article>
  );
};